import axios from 'axios';

/**
 * LA LINGUA SUL CONTO: quando il cliente collegato sceglie un'altra lingua
 * dalla tendina, user-management la tiene (POST /profile/lingua), cosi'
 * email, SMS e Telegram partono in quella anche a browser chiuso.
 *
 * Non blocca niente: senza accesso non parte, e un errore non si mostra (il
 * sito cambia lingua lo stesso; il conto la ricevera' alla prossima scelta).
 */
export function salvaLinguaSulConto(codice) {
  if (!codice || typeof window === 'undefined') return Promise.resolve(false);
  let token = null;
  try { token = window.localStorage.getItem('access_token'); } catch (e) { token = null; }
  if (!token) return Promise.resolve(false);
  const env = window.env || {};
  const h = {'Content-Type': 'application/json', 'X-Client-Surface': 'FRONTEND', Authorization: `Bearer ${token}`};
  if (env.REACT_APP_API_TENANT) h.TENANT_ID = env.REACT_APP_API_TENANT;
  return axios.post(`${env.REACT_APP_API_URL || ''}/profile/lingua`, {lingua: codice}, {headers: h})
    .then(() => true, () => false);
}
